import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import { LinkButton } from '@client/toolkit';

import { PortfolioPaths } from '../../../portfolio.router';

export function PortfolioImportButton() {
  const { t: tCommon } = useTranslation('common');

  return (
    <LinkButton color="primary-dark" className="leading-8" to={generatePath(PortfolioPaths.PortfolioImport)}>
      {tCommon('import')}
    </LinkButton>
  );
}
